import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import useTranslation from "../hooks/useTranslation";

import TEXT from "../config/text";
import Message from "./Message";
// import style from "./style/macInputStyle.module.scss";
import REQUESTS from "../api/requests";
import computerIcon from "../assets/computer.png";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actions } from "../store";

/**
 *
 * @param {boolean} reset           In order to reset the component state
 * @param {func} setMacIsValid      Տo pass the mac address status to the parent
 * @param {bool} appColor           To match the prevailing hue
 *
 * @returns Input
 */

export default function ValidateMacAddress({
  defaultMac,
  setMacIsValid,
  value = "",
  setValue,
  setDevice,
  isLogin = false,
}) {
  console.log(isLogin, "isLogin ");
  const dispatch = useDispatch();
  const { setDeviceFromStore } = bindActionCreators(actions, dispatch);

  const translation = useTranslation();

  const [message, setMessage] = useState({
    text: "",
    type: true,
  });

  const handleText = (text) => {
    if (translation?.general?.[text]) {
      return translation?.general?.[text];
    }

    return TEXT?.general?.[text];
  };

  const validateMacAddress = () => {
    if (value?.length === 0) {
      return;
    }

    function callback(data) {
      if (setDevice) {
        setDevice(data);
        if (isLogin) setDeviceFromStore(data);
      }

      setMacIsValid(true);
      setMessage({
        text: handleText("mac_input_valid_message"),
        type: true,
      });
    }

    function errorCallback(error) {
      setMacIsValid(false);
      console.log(error, "error");
      setMessage({
        text: handleText("mac_input_not_valid_message"),
        type: false,
      });
    }

    REQUESTS.VALIDATE_MAC(value, callback, errorCallback);
  };

  const generateMacFormat = (e) => {
    var mac = e.target.value.replace(/[^0-9a-z]/gi, "");
    var result = "";

    for (var i = 0; i < mac.length; i++) {
      if (i % 2 === 0 && i !== 0) {
        result += ":";
      }
      result += mac[i];
    }
    setValue(result.substring(0, 17));
  };

  useEffect(() => {
    if (value?.length === 17) {
      validateMacAddress();
    } else {
      setMessage({
        text: "",
        type: false,
      });
    }
  }, [value]);

  useEffect(() => {
    if (defaultMac) {
      setValue(defaultMac);
    }
  }, [defaultMac]);

  return (
    <div className={"custom-mac-input-container"}>
      <input
        value={value}
        onChange={generateMacFormat}
        placeholder={handleText("mac_input_placeholder")}
        name="mac"
        id="mac"
        className={"mac-inp"}
      />
      <Message message={message} />
    </div>
  );
}

ValidateMacAddress.propTypes = {
  appColor: PropTypes.bool,
  reset: PropTypes.bool,
  setMacIsValid: PropTypes.func.isRequired,
};
